import React, { Component } from 'react';
import PropTypes from 'prop-types';

class View extends Component {
  render() {
    const { displays } = this.props;

    const getIsEmpty = (x) => {
      return x === undefined || x === null || x === '' ? 'empty' : undefined;
    };

    return (
      <table className="responsive">
        <thead>
          <tr>
            <th colSpan="2">クラス・コース情報</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>校舎</th>
            <td><span>{displays.location}</span></td>
          </tr>
          <tr>
            <th>曜日</th>
            <td><span>{displays.day_location}</span></td>
          </tr>
          <tr>
            <th>コース</th>
            <td><span>{displays.course}</span></td>
          </tr>
          <tr>
            <th>持ち込みPCの種類</th>
            <td><span className={getIsEmpty(displays.pc_type)}>{displays.pc_type}</span></td>
          </tr>
          <tr>
            <th>Life is Tech ! Schoolをどうやって知りましたか </th>
            <td><span>{displays.learned_reason}</span></td>
          </tr>
          <tr>
            <th>質問・要望</th>
            <td><span className={getIsEmpty(displays.comment)}>{displays.comment}</span></td>
          </tr>
          <tr>
            <th>パソコン経験</th>
            <td><span className={getIsEmpty(displays.experience)}>{displays.experience}</span></td>
          </tr>
        </tbody>
      </table>
    );
  }
}

View.propTypes = {
  displays: PropTypes.shape({
    location: PropTypes.string,
    day_location: PropTypes.string,
    course: PropTypes.string,
    pc_type: PropTypes.string,
    learned_reason: PropTypes.string,
    comment: PropTypes.string,
    experience: PropTypes.string,
  }).isRequired,
};

export default View;
